<template>
  <v-row style="height: 100%;">
    <v-col>
      <transition name="fade-up" mode="out-in" appear>
        <router-view />
      </transition>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Billing',
  data: () => ({

  }),
  methods: {

  }
}
</script>